import {InvoiceableRepository} from '@/modules/facturae/domain/InvoiceableRepository'
import {FileRepository} from '@/modules/shared/domain/FileRepository'
import {InvoiceEditorScreenData} from '@/modules/facturae/domain/InvoiceEditorScreenData'
import {InvoiceLine, Tax, STATE_TRANSLATOR, PAYMENT_STATE_TRANSLATOR, recargo_rates, ExtraAmount} from '@/modules/facturae/domain/Invoiceable'
import { ProductRepository } from '../domain/ProductRepository'
import { jobs } from "@/api/jobs"
import { ConfigurationRepository } from '../domain/ConfigurationRepository'
export class InvoiceEditorComponent{
    
    invoice_repo:InvoiceableRepository
    file_repo:FileRepository
    screen_data: InvoiceEditorScreenData
    state_translator= STATE_TRANSLATOR
    payment_state_translator = PAYMENT_STATE_TRANSLATOR
    recargo_rates = recargo_rates
    product_repo:ProductRepository
    config_repo:ConfigurationRepository
    invoiceable_type:string
    currentCompany: any
  
    constructor(
        invoice_repo: InvoiceableRepository,
        file_repo: FileRepository,
        screen_data: InvoiceEditorScreenData,
        product_repo: ProductRepository,
        config_repo: ConfigurationRepository,
        invoiceable_type: string,
        currentCompany: any
      ) {
        this.invoice_repo = invoice_repo;
        this.file_repo = file_repo;
        this.screen_data = screen_data;
        this.product_repo = product_repo;
        this.config_repo = config_repo;
        this.invoiceable_type = invoiceable_type;
        this.currentCompany = currentCompany;
      }

    async mountEditor(invoiceable_id: string|Number, companydb_id, next_number: string, next_rectificative_number:string, default_sequence_id:Number) {
        let products = await this.product_repo.getProductList(companydb_id, {})
        this.screen_data.setProducts(products)
        let rectificative_invoice = null
        // this.screen_data.configuration = await this.config_repo.get_configuration(companydb_id, this.invoiceable_type)
        let config = await this.config_repo.get_configuration(companydb_id, this.invoiceable_type)
        this.screen_data.setConfiguration(config)
        let tax_type = this.screen_data.configuration?.tax_type ? this.screen_data.configuration.tax_type : 'iva'
        let invoiceable = await this.invoice_repo.create_empty_invoiceable(companydb_id, this.currentCompany, next_number, next_rectificative_number, tax_type, this.invoiceable_type)
        if (invoiceable_id) {
            invoiceable = await this.invoice_repo.find_by_id(invoiceable_id)
            if (this.invoiceable_type == 'invoice' && invoiceable.rectificative_info && invoiceable.rectificative_info.invoice_id) {
                rectificative_invoice = await this.invoice_repo.find_by_id(invoiceable.rectificative_info.invoice_id)
            }
            if (!invoiceable) {
                return false;
            }
    
        } else {
            if (default_sequence_id) {
                invoiceable.sequence_id = default_sequence_id
            }
        }
        if (invoiceable.sequence_id) {
            if (invoiceable.is_from_recurring_contract) {
                this.screen_data.setConfiguration(config, true)
            }
            let seq = this.screen_data.configuration.sequences.find(s => s.id == invoiceable.sequence_id)
            if (seq) {
                this.screen_data.setSequence(seq)
            }
        }
        this.screen_data.setInvoice(invoiceable)
        this.screen_data.setRectificativeInvoice(rectificative_invoice)
        await this.uploadCustomers()
        return true
    }
  
    async import_excel_lines(){
        let res = await this.screen_data.ask_for_file()
        if(res && this.screen_data.file){  
            var file = this.screen_data.file
        }
        else{
            return
        }
        this.screen_data.setLoading(true)
        let path = await this.file_repo.uploadFile(file)
        console.log('saving')
        let my_inv_id = await this.invoice_repo.save(this.screen_data.invoice)
        console.log('got_id', this.screen_data.invoice.id)
        await this.invoice_repo.import_lines_from_excel(my_inv_id, path)
        let inv = await this.invoice_repo.find_by_id(my_inv_id)
        this.screen_data.setInvoice(inv)
        this.screen_data.file = null
        this.screen_data.setLoading(false)
    }

    // updateLine(line:InvoiceLine) {
    //     const actual_round = (value: number) => Math.round(value * 100) / 100;
    //     if (line.selected_product) {
    //         line.product_code = line.selected_product.code
    //         line.description = line.selected_product.description
    //         line.unit_price_without_tax = line.selected_product.price
    //         line.selected_tax = line.selected_product.selected_tax
    //         line.selected_retention = line.selected_product.selected_retention
    //         if (line.selected_product.selected_tax == 0.0 && line.selected_product.selected_tax_event) {
    //             line.selected_tax_event = line.selected_product.selected_tax_event
    //         }
    //         if (line.quantity == 0){
    //             line.quantity = 1
    //         }
    //         line.selected_product = null
    //     }
    //     let reason = ''
    //     if (line.selected_tax_event){
    //         if (line.selected_tax_event == 'ISP'){
    //             reason = 'Inversión del sujeto pasivo en virtud del art 84.Uno de la Ley 37/1992, del IVA.'
    //             line.special_taxable_event = {code:'01', reason:reason}
    //         }
    //         else if (line.selected_tax_event == 'NS'){
    //             reason  = 'Operación no sujeta a IVA en virtud del art. 7 de la Ley 37/1992, del IVA.'
    //             line.special_taxable_event = {code:'02', reason:reason}
    //         }
    //         else if (line.selected_tax_event == 'EX'){
    //             reason = 'Operación exenta en virtud del art. 20 de la Ley 37/1992, del IVA.'
    //             line.special_taxable_event = {code:'01', reason:reason}
    //         }
    //         else if(line.selected_tax_event == 'INTRA.'){
    //             reason = 'Entrega intracomunitaria exenta en virtud del art. 25 de la Ley 37/1992, del IVA.'
    //             line.special_taxable_event = {code:'01', reason:reason}
    //         }
    //         else if(line.selected_tax_event == 'EXPORT.'){
    //             reason = 'Operación exenta por exportación en virtud del art. 21 de la Ley 37/1992, del IVA.'
    //             line.special_taxable_event = {code:'01', reason:reason}
    //         }
    //         else{
    //             line.special_taxable_event = null
    //         }
    //     }
    //     if (line.selected_tax != 0.0){
    //         line.selected_tax_event = 'N/A'
    //         line.special_taxable_event = null
    //     }
        
    //     line.total_cost = actual_round(line.quantity * line.unit_price_without_tax)
    //     line.gross_amount = line.total_cost
    //     if (Object.keys(this.recargo_rates).includes(line.selected_tax.toString())){
    //         line.taxes[0].rate = this.recargo_rates[line.selected_tax]
    //         line.taxes[0].recargo_rate = line.selected_tax
    //         line.taxes[0].amount = actual_round(line.total_cost * line.taxes[0].rate)
    //         line.taxes[0].recargo_amount = actual_round(line.total_cost * line.taxes[0].recargo_rate)
    //     }
    //     else{
    //         line.taxes[0].rate = line.selected_tax
    //         line.taxes[0].amount = actual_round(line.total_cost * line.taxes[0].rate)
    //         line.taxes[0].recargo_amount = 0
    //         line.taxes[0].recargo_rate = null
    //     }
    //     line.taxes[0].base = line.total_cost

    //     if (line.selected_retention == 'na'){
    //         line.taxes_withheld = []
    //     }
    //     else{
    //         let rate = parseFloat(line.selected_retention)
    //         line.taxes_withheld = [new Tax(rate, line.total_cost, actual_round(line.total_cost*rate))]
    //     }
    //     return line
    // }

    update_invoice_line(i){
        let line = this.screen_data.invoice.lines[i]
        if (line) {
            let updated_line = line.updateLine()
            let lines = this.screen_data.invoice.lines
            lines[i] = updated_line
            this.screen_data.setLines(lines)
        }
    } 
    async save_invoice(){
        this.screen_data.setLoading(true)
        // console.log(this.screen_data.invoice)
        let inv_id = await this.invoice_repo.save(this.screen_data.invoice)
        let msg = ''
        if (inv_id){
            let inv = await this.invoice_repo.find_by_id(inv_id)
            this.screen_data.setInvoice(inv)
            msg = this.invoiceable_type == 'invoice' ? 'Factura guardada' : this.capitalizeFirstLetter(this.screen_data.invoice.name) + ' guardado'
            this.screen_data.success_message(msg)
        }
        else {
            msg = this.invoiceable_type == 'invoice' ? 'Error guardando factura' : 'Error guardando ' + this.screen_data.invoice.name
            this.screen_data.error_message(msg)
        }
        this.screen_data.setLoading(false)
    }
    add_line(){
        let default_tax = 0.21
        let tax_type = this.screen_data.invoice.tax_type? this.screen_data.invoice.tax_type : 'iva'
        console.log('tax_type', tax_type)
        if(!tax_type.includes('iva') && tax_type.includes('igic')){
            default_tax = 0.07
        }
        let line = new InvoiceLine('', 0,0,0,0, [new Tax(default_tax,0,0)])
        line.selected_tax = default_tax
        line.discounts = [new ExtraAmount('Descuento', 0, 0)]
        let lines = this.screen_data.invoice.lines
        lines.push(line)
        this.screen_data.setLines(lines)
    }
    delete_line(i){
        let lines = this.screen_data.invoice.lines
        lines.splice(i,1)
        this.screen_data.setLines(lines)
    }
    async delete_all_lines(){
        let accept = await this.screen_data.delete_all_lines_dialog()
        if (accept){
            this.screen_data.setLoading(true)
            this.deleteLinesInBatches(50);
        }
    }

    deleteLinesInBatches(batchSize) {
        let lines = this.screen_data.invoice.lines
    
        const processBatch = () => {
            if (lines.length > 0) {
                // Remove the first batchSize lines
                lines = lines.slice(batchSize);
                this.screen_data.setLines(lines);
    
                // Log progress if needed
                console.log(`Batch processed, remaining lines: ${lines.length}`);
    
                // Schedule the next batch for the next event loop cycle
                setTimeout(() => {
                    processBatch();
                }, 0);
            } else {
                this.screen_data.setLoading(false);
                console.log('All lines deleted');
                this.update_invoice();
            }
        };
    
        // Start processing the first batch
        setTimeout(() => {
            processBatch();
        }, 0);
    }

    update_invoice(){
        const default_reasons= ['Inversión del sujeto pasivo en virtud del art 84.Uno de la Ley 37/1992, del IVA.',
        'Operación no sujeta a IVA en virtud del art. 7 de la Ley 37/1992, del IVA.',
        'Operación exenta en virtud del art. 20 de la Ley 37/1992, del IVA.',
        'Entrega intracomunitaria exenta en virtud del art. 25 de la Ley 37/1992, del IVA.',
        'Operación exenta por exportación en virtud del art. 21 de la Ley 37/1992, del IVA.',null,'', undefined]
        if (this.screen_data.invoice.state == 'draft'){
            let reason = ''
            for(let line of this.screen_data.invoice.lines){
                if(line.taxes[0].rate == 0.0){
                    // console.log(line)
                    reason = line.special_taxable_event? line.special_taxable_event['reason'] : ''
                    break
                }
            }
            this.screen_data.invoice.additional_info = this.screen_data.invoice.additional_info? this.screen_data.invoice.additional_info : ''
            if (default_reasons.some(default_reason => this.screen_data.invoice.additional_info.includes(default_reason))){ // replaceable observaciones (solo si es 0)
                for (let default_reason of default_reasons) {
                    if (this.screen_data.invoice.additional_info.includes(default_reason)) {
                        if ([null, '', undefined].includes(default_reason) && this.screen_data.invoice.additional_info.length > 0) {
                            if (!this.screen_data.invoice.additional_info.endsWith('\n')) {
                                this.screen_data.invoice.additional_info += '\n';
                            }
                            this.screen_data.invoice.additional_info += reason;
                        } else {
                            this.screen_data.invoice.additional_info = this.screen_data.invoice.additional_info.replace(default_reason, reason);
                        }
                        break;
                    }
                }
            }
        }
        this.screen_data.invoice.compute()
    }

    async download_e_invoice(){
        try {
            let inv_id = await this.invoice_repo.save(this.screen_data.invoice)
            this.screen_data.download_loading = true
            let res = null
            this.screen_data.action = 'download'
            if (this.screen_data.download_type == 'pdf') {
                res = await this.invoice_repo.download_pdf(inv_id)
            } else if (this.screen_data.download_type == 'xml') {
                res = await this.invoice_repo.download_xml(inv_id)
            } else {
                this.screen_data.error_message('Tipo de descarga no válido');
                return;
            }
            this.screen_data.asyncJobState = 'running';
            this.screen_data.asyncJobId = res.job_id;
        } catch (e) {
            this.screen_data.error_message('Error al descargar ' + this.screen_data.invoice.name);
        }
        this.screen_data.download_loading = false;
        this.screen_data.downloadPopup = false;
        
    }

    async download_from_url(s_url){
        const response = await fetch(s_url)
        if (!response.ok || response.type === 'opaque') {
            throw new Error('Error al descargar ' + this.screen_data.invoice.name);
        }
        const blob = await response.blob();
        const url = await URL.createObjectURL(blob)
        const a = document.createElement("a");
        a.href = url;
        let ext = ''
        if (this.screen_data.download_type == 'pdf') {
            ext = 'pdf'
        } else {
            if (this.screen_data.invoice.state == 'signed') {
                ext = 'xsig'
            } else {
                ext = 'xml'
            }
        }
        if (this.screen_data.invoice.state == 'draft') {
            a.download = `factura${this.screen_data.invoice.id}_${new Date().toISOString().replace(/T/, '_').replace(/\..+/, '')}.${ext}`;
        } else {
            a.download = `factura_${this.screen_data.invoice.invoice_number}.${ext}`;
        }
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        this.screen_data.download_type = '';
    }

    async jobDone(){
        const response = await jobs.getJob({ id: this.screen_data.asyncJobId });
        this.screen_data.asyncJobState = response.data.state;
        if (this.screen_data.action == 'download') {
            let recived_url = response.data.output_info.url
            try {
                await this.download_from_url(recived_url)
                this.screen_data.success_message('Descarga completada')
            } catch (e) {
                this.screen_data.error_message('Error al descargar ' + this.screen_data.invoice.name)
            }
        } else if (['send_email', 'send_accounting', 'send_invoice'].includes(this.screen_data.action)) {
            let success = response.data.output_info.success
            let message = response.data.output_info.message
            if (success) {
                this.screen_data.success_message('Envio realizado con exito')
            } else {
                this.screen_data.error_message('Error: '.concat(message))
            }
            let inv = await this.invoice_repo.find_by_id(this.screen_data.invoice.id)
            this.screen_data.setInvoice(inv)
            this.screen_data.senderOption = '';
            this.screen_data.emailForm = {
                to: '',
                subject: '',
                body: ''
            }
        }
    }

    async sign_invoice(){
        this.screen_data.setLoading(true)
        let inv_id = await this.invoice_repo.save(this.screen_data.invoice)
        let signed = await this.invoice_repo.sign(inv_id)
        let inv = await this.invoice_repo.find_by_id(inv_id)
        this.screen_data.setInvoice(inv)
        if(signed){
            this.screen_data.success_message('Factura firmada')
        }
        else{
            this.screen_data.error_message('Error firmando factura')
        }
        this.screen_data.setLoading(false)
    }

    async issue_invoice() {
        this.screen_data.setLoading(true)
        let inv_id = await this.invoice_repo.save(this.screen_data.invoice)
        let issued = await this.invoice_repo.issue(inv_id)
        let inv = await this.invoice_repo.find_by_id(inv_id)
        this.screen_data.setInvoice(inv)
        if(issued){
            this.screen_data.success_message(this.capitalizeFirstLetter(this.screen_data.invoice.name) +  ' emitido correctamente')
        }
        else{
            this.screen_data.error_message('Error emitiendo ' + this.screen_data.invoice.name)
        }
        this.screen_data.setLoading(false)
    }

    async send_e_invoice() {
        this.screen_data.send_loading = true
        if (this.screen_data.senderOption == 'EMAIL') {
            await this.send_invoice_email()
        }
        else if (this.screen_data.senderOption == 'FACEB2B' || this.screen_data.senderOption == 'FACE') {
            let mode = this.screen_data.senderOption == 'FACEB2B' ? 'b2b' : 'face'
            await this.send_invoice(mode)
        }
        else if (this.screen_data.senderOption == 'CONT') {
            await this.send_invoice_to_accounting()
        }
        this.screen_data.send_loading = false
        this.screen_data.send_dialog = false
    }

    async send_invoice(mode='b2b'){
        try {
            let inv_id = await this.invoice_repo.save(this.screen_data.invoice)
            let res = await this.invoice_repo.send(inv_id, mode)
            this.screen_data.action = 'send_invoice'
            this.screen_data.asyncJobState = 'running';
            this.screen_data.asyncJobId = res.job_id;
        } catch (err) {
            this.screen_data.error_message('Error al enviar la factura')
        }
    }

    async uploadCustomers() {
        let customers = await this.invoice_repo.get_customer_list(this.screen_data.invoice.company_id)
        let actual_customer = this.screen_data.invoice.customer
        // TODO: Implementes this if only to fix already existing customer tht has no customer id
        if (actual_customer.id == null) {
            let match = customers.find(c => c.cif == actual_customer.cif)
            if (match) {
                this.screen_data.invoice.customer.id = match.id
            }
        }
        if (this.screen_data.invoice.customer && this.screen_data.invoice.customer.id == null) {
            customers.push(this.screen_data.invoice.customer)
        }
        this.screen_data.setCustomers(customers)
    }

    refresh_emisor(currentCompany){
        let supplier = this.invoice_repo.supplier_from_current_company(currentCompany)
        this.screen_data.invoice.supplier = supplier
    }

    show_supplier_pop_up(){
        console.log('showing supplier pop up')
        this.screen_data.supplier_pop_up = true;
    }

    show_customer_pop_up(){
        this.screen_data.customer_pop_up = true;
    }

    async reject_invoice() {
        this.screen_data.setLoadingReject(true)
        let res = await this.invoice_repo.reject_invoiceable(this.screen_data.invoice.id, this.screen_data.reject_comment)
        this.screen_data.setLoadingReject(false)
        this.screen_data.setRejectDialog(false)
        let message = ''
        if (res == 'ok') {
            message = this.invoiceable_type == 'invoice' ? 'Factura rechazada' : this.capitalizeFirstLetter(this.screen_data.invoice.name)+' rechazado'
            this.screen_data.success_message(message)
            let inv = await this.invoice_repo.find_by_id(this.screen_data.invoice.id)
            this.screen_data.setInvoice(inv)
        } else {
            message = this.invoiceable_type == 'invoice' ? 'Error rechazando factura' : 'Error rechazando '+ this.screen_data.invoice.name
            this.screen_data.error_message(message)
        }
    }

    capitalizeFirstLetter(val) {
        return String(val).charAt(0).toUpperCase() + String(val).slice(1);
    }

    async pay_accept_invoice() {
        this.screen_data.setLoadingPaid(true)
        if (['budget', 'delivery_note'].includes(this.invoiceable_type)) {
            this.screen_data.invoice.state = 'accepted'
            try {
                await this.invoice_repo.save(this.screen_data.invoice)
            } catch (error) {
                this.screen_data.error_message('Error aceptando ' + this.screen_data.invoice.name)
                return
            }
            this.screen_data.setLoadingPaid(false)
            this.screen_data.setPaidDialog(false)
            // this.screen_data.success_message(this.screen_data.invoice.name + ' aceptado')
            this.screen_data.success_message(this.capitalizeFirstLetter(this.screen_data.invoice.name) + ' aceptado')
        } else {
            let res = await this.invoice_repo.pay_downloaded_invoice(this.screen_data.invoice.id)
            this.screen_data.setLoadingPaid(false)
            this.screen_data.setPaidDialog(false)
            if (res == 'ok') {
                this.screen_data.success_message('Factura pagada')
            } else {
                this.screen_data.error_message('Error pagando factura')
            }
        }
        if (this.screen_data.invoice) {
            let inv = await this.invoice_repo.find_by_id(this.screen_data.invoice.id)
            this.screen_data.setInvoice(inv)
        }
    }

    async unsign_invoice() {
        this.screen_data.setLoading(true)
        let inv_id = await this.invoice_repo.save(this.screen_data.invoice)
        let unsigned = await this.invoice_repo.unsign(inv_id)
        let inv = await this.invoice_repo.find_by_id(inv_id)
        inv.compute()
        this.screen_data.setInvoice(inv)
        if(unsigned){
            this.screen_data.success_message('Factura desfirmada')
        }
        else{
            this.screen_data.error_message('Error desfirmando factura')
        }
        this.screen_data.setLoading(false)
    }

    async send_invoice_email(){
        try {
            let inv_id = await this.invoice_repo.save(this.screen_data.invoice)
            let res = await this.invoice_repo.send_invoice_email(inv_id, this.screen_data.emailForm)
            this.screen_data.action = 'send_email'
            this.screen_data.asyncJobState = 'running';
            this.screen_data.asyncJobId = res.job_id;
        } catch (error) {
            this.screen_data.error_message('Error al enviar ' + this.screen_data.invoice.name)
        }
    }

    async send_invoice_to_accounting(){
        try {
            let inv_id = await this.invoice_repo.save(this.screen_data.invoice)
            let res = await this.invoice_repo.send_invoice_accounting(inv_id)
            this.screen_data.action = 'send_accounting'
            this.screen_data.asyncJobState = 'running';
            this.screen_data.asyncJobId = res.job_id;
        } catch (error) {
            this.screen_data.error_message('Error al enviar la factura')
        }
    }

    async save_third_party(third) {
        let res = await this.invoice_repo.save_third(third)
        if (res.status == 'ok') {
            this.screen_data.success_message('Tercero guardado correctamente')
            await this.uploadCustomers()
            if ([0, -1].includes(this.screen_data.invoice.customer.id)) {
                if (res.message['id']) {
                    let third = this.screen_data.customers.find(c => c.id == res.message['id'])
                    this.screen_data.invoice.customer = third
                }
            } else {
                this.screen_data.invoice.customer = third
            }
        } else {
            if (res.message == 'Third CIF already exists') {
                this.screen_data.error_message('El CIF ya existe')
            }
            else {
                this.screen_data.error_message('Error guardando tercero')
            }
        }
        // await this.invoice_repo.save(this.screen_data.invoice)
    }

    async save_company_as_party(supplier) {
        // console.log(supplier)
        let res = await this.invoice_repo.save_company_as_party(supplier)
        if (res.status == 'ok') {
            this.screen_data.success_message('Emisor guardado correctamente')
            this.screen_data.invoice.supplier = supplier
        }
        else {
            if (res.message == 'Company CIF does not match') {
                this.screen_data.error_message('El CIF del emisor no coincide con el CIF empresa')
            } else {
                this.screen_data.error_message('Error guardando emisor')
            }
        }
        // await this.invoice_repo.save(this.screen_data.invoice)
    }

    sequenceChanged() {
        for (let i in this.screen_data.availableSequences) {   
            // console.log(this.screen_data.configuration.sequences[i])
            if (this.screen_data.availableSequences[i].id == this.screen_data.invoice.sequence_id) {
                // console.log(this.screen_data.configuration.sequences[i])
                this.screen_data.invoice.predicted_invoice_number = this.screen_data.availableSequences[i].next_number;
                this.screen_data.invoice.predicted_rectificative_invoice_number = this.screen_data.availableSequences[i].next_rectificative_number;
            }
        }
        let seq = this.screen_data.availableSequences.find(s => s.id == this.screen_data.invoice.sequence_id)
        if (seq) {
            this.screen_data.setSequence(seq)
        }
    }
  }